import {
  AllowedCallTypes,
  makeApiStateSelectors
} from "seneca-common/utils/apiStates";

import { trialsCrudStateConfig } from "../../../consts";

const {
  [AllowedCallTypes.FETCH_ALL]: {
    hasStarted: trialsAreFetching,
    didSucceed: trialsFetchSucceeded,
    didError: trialsFetchErrored,
    hasFinished: trialsFetchFinished,
    notSucceededOrStarted: trialsNeedFetching
  },
  [AllowedCallTypes.UPDATE]: {
    hasStarted: trialIsUpdating,
    didSucceed: trialUpdateSucceeded,
    didError: trialUpdateErrored
  }
}: any = makeApiStateSelectors(trialsCrudStateConfig);

export {
  trialsAreFetching,
  trialsFetchSucceeded,
  trialsFetchErrored,
  trialsFetchFinished,
  trialsNeedFetching,
  trialIsUpdating,
  trialUpdateSucceeded,
  trialUpdateErrored
};
